import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";

import { fetchAlertsTrendByCompany as fetchAlertsTrendService } from "services/modules/vapt/data";

import CircularProgress from '@mui/material/CircularProgress';
import Chart from "react-apexcharts";


const VulnerabilityTrendAnalysis = ({ activeFilter, reportDate }) => {
  // Redux selectors
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);

  // State Variables
  const [vulnerabilityAnalysisChartOptions, setVulnerabilityAnalysisChartOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const chartState = {
    options: {
      chart: {
        fontFamily: '"Montserrat", "Open Sans", sans-serif',
        height: 275,
        type: "line",
        zoom: { enabled: false },
        toolbar: { show: false }
      },
      markers: { size: 6 },
      stroke: { width: 3, curve: "smooth" },
      legend: {
        position: "top",
        markers: { width: 10, height: 10 },
      },
      tooltip: { shared: false },
      yaxis: { title: { text: "Findings Count" } },
    },
    series: []
  };
  
  // Fetches Vulnerability trend graph based on company id
  const fetchVulnerabilityTrendData = async () => {
    setLoading(true);
    try {
      let params = {
        id: selectedCompanyContainer.companyid,
      };

      if (activeFilter) {
        if (activeFilter === 7) {
          params.days = activeFilter;
        }else if(activeFilter ===1){
          params.weeks = 30
        }
         else if (activeFilter >= 14) {
          params.weeks = activeFilter;
        } else {
          params.months = activeFilter;
        }
      }
      const response = await fetchAlertsTrendService({ params });
      const graphData = response.data?.data;
      let categories =activeFilter === 1 ? getWeekNames() :  activeFilter >= 14 ? getWeekNames() : getDateNames();
      if (activeFilter === 7) categories = getWeekNames();
      let chartSeries = response?.data?.data?.map(subcat => ({
        name: subcat.subcategory,
        data: new Array(categories?.length).fill(0),
      })) || [];
      chartSeries.forEach(series => {
        const data = graphData.find(d => d.subcategory === series.name);
        if (data) {
          series.data = data.monthlyCounts
            .sort((a, b) => new Date(a.endDate) - new Date(b.endDate))
            .map(count => count.count);
        }
      });

      chartState.options = { ...chartState.options, xaxis: { categories } };
      chartState.series = chartSeries;
      setVulnerabilityAnalysisChartOptions(chartState);
    } catch (error) {
      console.error("Failed to fetch vulnerability trend data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (activeFilter) {
      fetchVulnerabilityTrendData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter, reportDate]);
  
  // Formats date names
  const getDateNames = () => {
    const dateStart = new Date();
    dateStart.setMonth(dateStart.getMonth() - (activeFilter - 1));
    dateStart.setDate(1);
    const dateEnd = new Date();
    const newTimeValues = [];

    while (dateEnd > dateStart || dateStart.getMonth() === dateEnd.getMonth()) {
      const formattedDate = dateStart.toLocaleString('default', { month: 'short', year: 'numeric' });
      newTimeValues.push(formattedDate);
      dateStart.setMonth(dateStart.getMonth() + 1);
    }
    return newTimeValues;
  };
  
  // Formts week names
  const getWeekNames = () => {
    if (activeFilter >= 14 || activeFilter === 7 || activeFilter === 1) {
      let timeValues = [];
      if (activeFilter === 14) {
        timeValues = ["Week 1", "Week 2"];
      } else if (activeFilter === 7) {
        timeValues = ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"];
      } else if (activeFilter === 21) {
        timeValues = ["Week 1", "Week 2", "Week 3"];
      } else if (activeFilter === 1) {
        timeValues = ["Week 1", "Week 2", "Week 3", "Week 4"];
      } else if (activeFilter === 42) {
        timeValues = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6"];
      }
      return timeValues;
    }
  };

  return (
    <div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
          <CircularProgress size={60} />
        </div>
      ) : vulnerabilityAnalysisChartOptions ? (
        <Chart
          options={vulnerabilityAnalysisChartOptions.options}
          series={vulnerabilityAnalysisChartOptions.series}
          type="line"
          height="250"
        />
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};

export default VulnerabilityTrendAnalysis;